module.exports = __webpack_public_path__ + "static/custom_projects_tufas-504c9b244fec11798a000bb56b188348.svg";